import React, { useEffect } from 'react'
import image5 from "./Image2/UGCLogo.png"
import image6 from "./Image2/BATU.png"
import image7 from "./Image2/msbte.png"
import image8 from "./Image2/health2.png"
import college from "./facilitiesphotos/college.jpg"
import image4 from "./facilitiesphotos/sliderphoto.jpg"
import { FaUniversity } from 'react-icons/fa'
import { MdLocalLibrary } from 'react-icons/md'
import { BsFillTelephoneInboundFill } from 'react-icons/bs'
import { ImBooks } from 'react-icons/im'
import { SiHomeassistantcommunitystore } from 'react-icons/si'
import { AiFillMedicineBox } from 'react-icons/ai'
import { Carousel } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { BsFillArrowRightCircleFill } from 'react-icons/bs'
import president from "./facilitiesphotos/president.jpg"
import pharms from './Image2/phrms.jpg'



const Home = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <>
   
      <Carousel fade className='margin-top2' >
        <Carousel.Item>
          <img

            className="d-block w-100 imagesize "
            src={image4}
            alt="Second slide"

          />
          <Carousel.Caption >
            <div className="slide-down  top" >
              <p  className="top-margin font-size-slider2">Welcome to our <span className='text-white'> organization </span> </p>
              <p className='text-white font-size-slider'><span style={{color:"rgb(109 173 51)"}}>  Education is the most </span> powerful weapon which you <br></br>can use to change the world</p>
            </div>
          </Carousel.Caption>

        </Carousel.Item>
        <Carousel.Item>
          <img

            className="d-block w-100 imagesize"
            src={image4}
            alt="Second slide"
          />

<Carousel.Caption >
            <div className="slide-down  top" >
              <p  className="top-margin font-size-slider2">Welcome to our <span className='text-white'> organization </span> </p>
              <p className='text-white font-size-slider'><span style={{color:"rgb(109 173 51)"}}>  Education is the most </span> powerful weapon which you <br></br>can use to change the world</p>
            </div>
          </Carousel.Caption>

        </Carousel.Item>
        <Carousel.Item>
          <img

            className="d-block w-100 imagesize"
            src={image4}
            alt="Third slide"
          />

<Carousel.Caption >
            <div className="slide-down  top" >
              <p  className="top-margin font-size-slider2">Welcome to our <span className='text-white'> organization </span> </p>
              <p className='text-white font-size-slider' ><span style={{color:"rgb(109 173 51)"}}>  Education is the most </span> powerful weapon which you <br></br>can use to change the world</p>
            </div>
          </Carousel.Caption>

        </Carousel.Item>
      </Carousel>


      <div className="container-fluid card-5">


        <div className="container mt-2">

          <div className="row">
            <div className="col-md-3">
              <div className="d-flex">

                <img src={image5} className="img-fluid mt-3" alt="error" style={{width:"75px",height:"80px" }}></img>
                <p className="mt-3 mx-1">
                  UGC Entitled
                  (University Grants Commission of India)
                </p>
              </div>

            </div>
            <div className="col-md-3"><div className="d-flex">

              <img src={image6} className="img-fluid mt-2"  style={{width:"75px",height:"80px" }} alt="error"></img>
              <p className="mt-3 mx-1">
              Dr. Babasaheb Ambedkar Technological University (DBATU) for B Pharm
              </p>
            </div></div>
            <div className="col-md-3"><div className="d-flex">

              <img src={image7} className="img-fluid mt-2" style={{width:"75px",height:"80px" }} alt="error"></img>
              <p className="mt-3 mx-1">
             
              Maharashtra State Board of Technical Education for D Pharm
              </p>
            </div></div>
            <div className="col-md-3"><div className="d-flex">

              <img src={image8} className="img-fluid mt-2 " style={{width:"75px",height:"80px" }} alt="error"></img>
              <p className="mt-3 mx-1">
                Approved by
                Government of India
                for Medical Eduction
              </p>
            </div></div>
          </div>
        </div>

      </div>
      <br></br>
      <br></br>

      <br></br>

      <div className='container'>

        <center><h1 style={{ color: "rgb(44 110 17)" }}>  <span style={{ color: "rgb(151 201 29)" }}>Girnai </span> Shikshan Sanstha</h1>
          <h2 className='mt-3' style={{ color: "rgb(44 110 17)" }}><span style={{ color: "rgb(151 201 29)" }}> Welcome to shinde </span>  institute of pharmacy and research</h2></center>
        <br></br>
        <br></br>
        <img src={college} alt="error" className="img-fluid rounded" style={{}} />
      </div>

      <br></br>
      <br></br>
      <div className='container-fluid w-100' style={{ background: "rgb(77 135 25)" }}>

        <div className='container text-white'>

          <br></br>
          <br></br>
          <div className="row w-100">


            <h1>Girnai Shikshan Sanstha</h1>
            <p style={{ fontSize: "18px" }}>

              Girnai shikshan sanstha was established in 1989.A total of four schools of girnai shikshan sanstha are located in pachora.it is reputed for the quality of its faculty and outstanding platform to the student for undergraduate and postgraduate program.
              Now girnai shikshan sanstha is starting shinde institute of pharmacy and research from this year.
            </p>
            <br></br>

          </div>
          <Link className="btn btn-outline-warning " to="/about" >Know more</Link>
        </div>
        <br></br>
        <br></br>
        <br></br>
      </div>

      <br></br>
      <br></br>



      <div className='container'>
        <div className="row">
          <div className='col-md-4 col-sm-12' style={{ marginTop: "1rem" }} >
            <center>  <img src={president} alt='error13' className='img-fluid imagesize2'></img></center>

          </div>
          <div className='col-md-8 col-sm-12' >
            <h2 style={{ color: "rgb(77 135 25)" }} className="mt-2">President's Message</h2>

            <p className='text-dark  mt-3' >
              Welcome to shinde institute of pharmacy and research, one of the prominent establishment of Girnai
              Shikshan Sanstha in Pachora. Girnai Shikshan Sanstha was instituted in the year 1989 with
              the objective of imparting quality education to the students. It has a chain of educational as
              well as social institutions. I strongly believe that the social transformation can be done
              through good education.

            </p>
            <p className='text-dark '>I congratulate the Student who select shinde institute of pharmacy and research for your education
              because, it provides the best and up-to-date education through modern medium of learning
              which includes digital classrooms, labs and Smartphone-app based classes. Our well
              designed and spacious college building and campus are adequate for the scholastic and coscholastic activities.
            </p>





          </div>


          <div className='row mt-5'>
            <div className='col-md-4  col-sm-12'>
              <h3 style={{ color: "rgb(77 135 25)" }}>OUR VISION</h3>
              <p className='text-dark'>
                Developing and conducting research to improve the safety and efficiency of the medication use system.</p>

            </div>
            <div className='col-md-8 col-sm-12'>
              <h3 style={{ color: "rgb(77 135 25)" }}>MISSION</h3>
              <p className='text-dark'>Our mission is to educate and inspire a diverse group of future pharmaceutical scientist to be leaders ,advance patient care and improve health for all.
                To generate human resource in the profession of pharmacy.
              </p>

            </div>
          </div>
        </div>
        <div className='row mt-4'>
          <h3 style={{ color: "rgb(77 135 25)" }}>INFRASTRUCTURE</h3>
          <p>The college is well known for the kind of facilities that it offers to make learning pleasure. For instance, a huge well stocked library offers a vast array of books, magazine and other reference material related to pharmacy. The college has invested heavily in thechnology so that student can avail state of the art equipment. the college also has a medicinal plant garden that consist of vast variety of herbs.</p>
        </div>

      </div>
      <br></br>


      <div className="container-fluid" style={{ background: "rgb(77 135 25)" }}>
       
          <div className="container">

<br></br>
            <h3 className='text-white'>WHY THIS COLLEGE?</h3>
            <br></br>
            <br></br>
            <div className="row mt-3">
              <div className="col-md-3 col-sm-12">
                <center>
                  <FaUniversity  className='text-white color zoom' style={{  fontSize: "55px" }}></FaUniversity>
                  {/* <img src={image11}></img> */}
                  <p className="mt-3 text-white" style={{ color: "#c99c1d" }}>Infrastructure
                  </p>
                </center>

              </div>
              <div className="col-md-3 col-sm-12">
                <center>
                  <ImBooks   className='text-white color zoom' style={{  fontSize: "55px" }}></ImBooks>
                  {/* <img src={image12}></img> */}

                  <p className="mt-3 text-white" style={{ color: "#c99c1d" }}>Best Content</p>
                </center>
              </div>


              <div className="col-md-3">
                <center>
                  <AiFillMedicineBox   className='text-white color zoom' style={{ fontSize: "55px" }}></AiFillMedicineBox>

                  <p className="mt-3 text-white" >specialized subject
                  </p>
                </center>

              </div>
              <div className="col-md-3">
                <center>
                  <SiHomeassistantcommunitystore   className='text-white color zoom' style={{  fontSize: "55px" }}></SiHomeassistantcommunitystore>

                  <p className="mt-3 text-white" > Assistance
                    & Recruitment</p>
                </center>
              </div>
            </div>
            <div className="row mt-5">

              <div className="col-md-3">
                <center>
                  <BsFillTelephoneInboundFill   className='text-white color zoom' style={{  fontSize: "50px" }}></BsFillTelephoneInboundFill>

                  <p className="mt-3 text-white" >24 x 7 Helpline</p>
                </center>
              </div>
              <div className="col-md-3">
                <center>
                  <MdLocalLibrary  className='text-white color zoom' style={{ fontSize: "55px" }}></MdLocalLibrary>
                  <p className="mt-3 text-white" >E-library Access</p>
                </center>
              </div>
            </div>


       
          </div>


        </div>
        <div className='container-fluid  '>

          <div className="container ">
            <br />
            <br />

            <div className="row mt-4">
              <div className='col-md-4 col-sm-12'  >
                <center>  <img src={pharms} alt='error13' className='img-fluid'></img></center>

              </div>
              <div className='col-md-8 col-sm-12' >
                <h3 style={{ color: "rgb(77 135 25)" }} className="mt-1">OPPORTUNITIES AND FUTURE SCOPE</h3>
                <p>In Production, Quality assurance, Quality Control, Regulatory Affairs, IPR, Marketing, Production development, Research and development.
                  Clinical research, pharmacovigilance, clinical data management in FDA.
                </p>
                <h5>In Government</h5>
                <p className="lineheight">

                  <BsFillArrowRightCircleFill style={{ color: "rgb(77 135 25)" }} />  Drug inspectore,assistant commissioner and joint commissioner in FDA<br></br>
                  <BsFillArrowRightCircleFill style={{ color: "rgb(77 135 25)" }} />   As a pharmacist in government hospital as well as hospital run by zilla parishad.<br></br>
                  <BsFillArrowRightCircleFill style={{ color: "rgb(77 135 25)" }} /> As a Drug Procurement officer.<br></br>
                  <BsFillArrowRightCircleFill style={{ color: "rgb(77 135 25)" }} /> In academics as a asst. Professor, assoc professor in various pharmacy college.<br></br>

                </p>

              </div>



            </div>

          </div>

        </div>




        <br></br>
        <br></br>
        <br></br>

        <div className='row head2 footer-booknow margin-bottom' style={{ background: "rgb(77 135 25)", marginBottom: "-2.9rem" }} >

          <div className='col-lg-8 col-md-8 ' style={{ color: "white", marginTop: "1.2rem", marginBottom: "1.2rem" }} >
            <center> <h3 className='small2'>Are you looking for Pharmacy <br></br> College ?</h3></center>

          </div>
          <div className='col-lg-4 col-md-4' style={{ color: "white", marginTop: "2.5rem" }}>
            <center>  <h4 className='small3 '><i className="fa fa-phone-square" ></i> Call +91 83800 48830 or  <span>    <Link to="/" type="button" className="btn btn-outline-warning mx-1" >
              Know more
            </Link></span></h4></center>


          </div>
        </div>

      </>
      )
}

      export default Home